import ProfileSalaryInfo from '@atoms/ProfileInformation';
import ProfilePhoneEnroll from '@atoms/ProfilePhoneEnroll';
import { Divider, Text, View } from '@components/primitives';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ProfileInformationProps = {
  showPhoneEnroll?: boolean;
  showSalaryInfo?: boolean;
};

function ProfileInformation({ showPhoneEnroll = false, showSalaryInfo = false }: ProfileInformationProps) {
  const { t } = useTranslation('common');

  return (
    <>
      <View style={appStyles.marginLeft(16)} marginY="16px">
        <Text testID="txtProfileInformation" variant="md-bold">
          {t('profile.information')}
        </Text>
        <ProfilePhoneEnroll showPhoneEnroll={showPhoneEnroll} />
        <ProfileSalaryInfo showSalaryInfo={showSalaryInfo} />
      </View>
      <Divider height="4px" style={{ backgroundColor: colors.neutral.mist }} />
    </>
  );
}

export default ProfileInformation;
